var App = App || {};

App.CommunityHighlights = (() => {
    'use strict';

    const init = (id) => {
        if (id.length) {
            const carousel1 = document.getElementById(id).querySelector('.splide-1');
            const carousel2 = document.getElementById(id).querySelector('.splide-2');
            const carousel3 = document.getElementById(id).querySelector('.splide-3');

            if (carousel1) {

                const splide1 = new Splide(carousel1, {
                    type: 'fade',
                    rewind: true,
                    arrows: false,
                    pagination: false,
                    fixedHeight: '603px',
                    mediaQuery: 'max',
                    breakpoints: {
                        575: {
                            fixedHeight: '253px'
                        }
                    }
                });

                const splide2 = new Splide(carousel2, {
                    type: 'fade',
                    rewind: true,
                    arrows: true,
                    pagination: false,
                    fixedHeight: '512px',
                    mediaQuery: 'max',
                    breakpoints: {
                        575: {
                            fixedHeight: '215px'
                        }
                    }
                });

                const splide3 = new Splide(carousel3, {
                    type: 'fade',
                    rewind: true,
                    arrows: false,
                    pagination: false,
                    fixedHeight: '542px',
                    mediaQuery: 'max',
                    breakpoints: {
                        575: {
                            fixedHeight: '227px'
                        }
                    }
                });
                splide2.sync(splide1);
                splide2.sync(splide3);
                splide1.mount();
                splide2.mount();
                splide3.mount();
            }
        }
    }

    return {
        init: init
    };
})();